import {
  CLEAR_REQUEST_STATUS
} from '../constants/ActionTypes'

export const doClearRequestStatus = () => ({ type: CLEAR_REQUEST_STATUS })
